export enum ReportStatuses {
  idle = 'PENDING',
  queued = 'QUEUED',
  inprogress = 'IN_PROGRESS',
  completed = 'COMPLETE',
  error = 'ERROR',
  stopped = 'STOPPED',
}

export enum ReportTypes {
  annotatedSource = 'annotatedSource',
  annotatedNew = 'annotatedNew',
  detailed = 'detailed',
  detailedThumbnails = 'detailedThumbnails',
  esko = 'EskoXFDF',
  kallik = 'KallikXFDF',
}

export interface Report {
  id: string;
  name: string;
  options: {
    type: ReportTypes;
  };
  status: ReportStatuses;
  path?: string;
  signedUrl: string;
  createdAt: string;
  currentPage: number;
}
